<template>
  <div class="create">
    <!-- model框 begin -->
    <div class="model">
      <div class="body">
        <p class="title"></p>
        <p class="content"></p>
        <p class="btns" style="display:none">
          <span class="cancel">取消</span>
          <span class="confirm">确定</span>
        </p>
        <p class="foot" style="display:block"></p>
      </div>
    </div>
    <!-- model框 end -->
    <!-- loading -->
    <div class="loading" id="loading" v-show="loading">
      <div class="circle"></div>
    </div>
    <!-- 顶部背景 -->
    <img src="../images/shop_top.jpeg" width="100%" />
    <div class="store-form">
      <div class="user-info">
        <section class="label bb clearfix">
          <label for="user_name">
            <span class="xing_red">＊</span>参保人姓名：
          </label>
          <input
            type="text"
            id="user_name"
            v-model="formData.userName"
            @focus="eidtName"
            maxlength="15"
            placeholder="请输入参保商家法定代表人（或经营者）"
            value
          />
        </section>

        <section class="label bb clearfix">
          <label>
            <span class="xing_red">＊</span>身份证号：
          </label>
          <input
            type="text"
            v-model="formData.idCard"
            @focus="eidtCard"
            placeholder="请输入身份证号"
            maxlength="18"
          />
        </section>
      </div>
      <div class="wifi-body" v-for="(item, key) in formData.apInfoList" :key="key">
        <div class="line"></div>
        <div class="wifi-info">
          <section class="label bb clearfix">
            <label for="demo_treelist_dummy">
              <span style="font-size: 16px; color: #FE2C54; letter-spacing: 0; line-height: 14px;">＊</span>热点名称：
            </label>
            <input
              type="text"
              style="width: 220px"
              v-model="item.ssid"
              @focus="eidtSsid"
              @input="changeText(item.ssid, key)"
              placeholder="手动输入WiFi热点名称"
            />
            <div class="select-wifi" v-if="!isIOS" @click="selectWifi(key)">
              选择附近WiFi
              <img src="../assets/arrow-right.png" class="arrow-right" />
            </div>
          </section>
          <section class="label bb clearfix">
            <label for="demo_treelist_dummy">
              <span class="xing_red">＊</span>路由器MAC地址：
            </label>
            <ul class="macList clearfix">
              <li v-for="(bssid, index) in item.bssidList" :key="index">
                <input type="text" @focus="eidtMac" v-model="bssid.title" maxlength="1" />
                <input type="text" @focus="eidtMac" v-model="bssid.title1" maxlength="1" />
                <span v-if="index !== (item.bssidList.length -1 )">:</span>
              </li>
            </ul>
            <p>MAC地址通常在路由器背面的铭牌上可以找到，由0-9之间的数字和a-f之间的字母组成</p>

            <section class="label bb clearfix">
              <label for="demo_treelist_dummy">
                <span class="xing_red">＊</span>请选择商户类型：
              </label>
              <div @click.stop="handleShopType(key)">
                <div class="arrow"></div>
                <input
                  type="text"
                  disabled
                  @click="()=>{}"
                  v-model="item.text"
                  placeholder="选择商户类型"
                  maxlength="18"
                />
              </div>
            </section>

            <section class="label bb clearfix">
              <label for="demo_treelist_dummy">
                <span class="xing_red">＊</span>请上传资质：
              </label>
              <p
                style="font-size: 14px; color: #666666; letter-spacing: 0; line-height: 26px;"
              >热点证明（路由器背面铭牌照片）</p>
              <div class="upload-img">
                <wk-single-image-upload
                  dest="wifikey"
                  @change="getHotspotEvidence"
                  v-model="item.hotspotEvidence"
                  :disabled="disabled"
                >
                  <solt name="loading" class="loading"></solt>
                </wk-single-image-upload>
              </div>
            </section>
          </section>
          <div class="btn-body">
            <div
              class="add"
              v-show="formData.apInfoList.length > 1"
              @click="handleWifi('del', key)"
            >
              <img class="add-img" src="../assets/delete-wifi.png" />
              <span class="delete-span">删除热点</span>
            </div>
            <div class="add" @click="handleWifi('add', key)">
              <img class="add-img" src="../assets/add-wifi.png" />
              <span class="add-span">添加热点</span>
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="footer">
      <div class="des">
        <h3 class>
          <span class="xing_red">＊</span>营业执照备案
        </h3>
        <div class="upload-img">
          <wk-single-image-upload
            dest="wifikey"
            @change="getBusinessLicense"
            v-model="formData.businessLicense"
            :disabled="disabled"
          >
            <solt name="loading" class="loading"></solt>
          </wk-single-image-upload>
        </div>
        <div class="notice">信息保护声明</div>
        <div class="noticeInfo">以上信息只供WiFi安全险登记及理赔用途，并不会用于其他商业用途。</div>
      </div>
      <p class="protocol">
        <van-checkbox icon-size="16" v-model="checked" @change='changeCheck' shape="square" checked-color="#07c160">
          本人同意并接受
          <router-link
            to="/new/protocol"
            @click="clickProtocol()"
            v-if="protocol == 'protocol'"
          >《WiFi万能钥匙商户热点安全保险协议》</router-link>
        </van-checkbox>
      </p>
      <p class="errorMsg"></p>
      <p class="buttons">
        <a class="button btn" @click="create">参保安心上网</a>
      </p>
    </div>
    <qa :type="4"></qa>
    <div class="logo-image"></div>
    <div class="copyright" style="padding-bottom:12px">南京尚网网络科技有限公司对以上信息保留最终解释权</div>

    <div class="alert-model" v-if="showAlertModel">
      <div class="body">
        <p class="title">温馨提示</p>
        <p class="content">{{modelContent}}</p>
        <p class="description">
          <img src="../assets/tip.png" />如手机号码有更换，请联系官方客服
        </p>
        <p class="description" style="margin-bottom: 20px">
          客服电话：<a href="tel:4000358000">4000358000</a>
          <span class="copy-qq" @click="copyQq(4000358000)">复制</span>
        </p>
        <p class="btns" style="display:none">
          <span class="cancel">取消</span>
          <span class="confirm">确定</span>
        </p>
        <p class="foot" style="display:block" @click="cancel">我知道了</p>
      </div>
    </div>

    <van-popup v-model="showPopup" position="bottom">
      <van-picker
        show-toolbar
        :default-index="2"
        :columns="columns"
        @confirm="onConfirm"
        @change="onChange"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import { Checkbox } from "vant";
import qa from "@/components/qa";
import { Picker, Toast, Popup } from "vant";
import {
  commitInsurance,
  getInsuranceQueryInfo,
} from "../services/common/index";
import Clipboard from "clipboard";
import wkSingleImageUpload from "../components/SingleImageUpload";

export default {
  name: "newcreateStore",
  components: {
    qa,
    wkSingleImageUpload,
    "van-picker": Picker,
    "van-popup": Popup,
  },
  data() {
    return {
      clear: null, // 清楚数据
      from: "home",
      columns: [
        { text: "餐饮美食", id: 0 },
        { text: "休闲娱乐(网吧、影院)", id: 1 },
        { text: "生活服务(小区超市、美甲店等便民设施)", id: 2 },
        { text: "宾馆酒店", id: 3 },
        { text: "购物（购物广场）", id: 4 },
      ],
      protocol: "protocol",
      showAlertModel: false,
      modelContent: "",
      loading: false,
      disabled: false,
      showPopup: false,
      selectWifiItem: {},
      selectNo: null,
      formData: {
        userName: "",
        idCard: "",
        businessLicense: "",
        apInfoList: [],
      },
      isFirstClickMac: true,
      apItem: {
        bssid: "",
        ssid: "",
        hotspotEvidence: "",
        merchantType: "",
        bssidList: [
          { title: "", title1: "" },
          { title: "", title1: "" },
          { title: "", title1: "" },
          { title: "", title1: "" },
          { title: "", title1: "" },
          { title: "", title1: "" },
        ],
      },
      isIOS: false,
      checked: false,
      isFromWifiList: false,
      isToEdit: true
    };
  },
  created() {
    this.formData.apInfoList.push(this.apItem);
    this.handlePageQuery();
    this.initInfo();
  },
  activated() {
    this.handlePageQuery();
  },

  beforeRouteEnter(to, from, next) {
    // ...
    next((vm) => {
      vm.isFromWifiList = false;
      // 选择WiFi列表进来
      if (from.name === "/new/wifiSelect") {
        vm.isFromWifiList = true;
        console.log(`vm=====`,vm.isToEdit)
        if (vm.isToEdit) {
          vm.initInfo();
        } else {
          if (vm.isFromWifiList) {
            vm.handleWifiaaaaa();
          }
        }
      } else if (from.name === "/new/protocol") {
      } else if (from.name === "/new/createSuccess") {
        // 修改保单信息
        vm.initInfo();
        vm.checked = true
      } else {
        vm.formData = {
          apInfoList: [],
        };
        vm.formData.apInfoList.push(vm.apItem);
      }
    });
  },
  mounted() {
    this.$trace.enterTraceDone({ page: 4 });
  },
  methods: {
    handlePageQuery() {
      this.clear = this.$route.query.clear;
      this.from = this.$route.query.from;
      if (this.$wkb.isWKBrowser === "ios") {
        this.isIOS = true;
      }
    },
    changeText(val, key) {
    },
    // 查询已提交的信息。
    initInfo() {
      this.isToEdit = false
      getInsuranceQueryInfo()
        .then((res) => {
          const { data, retCd } = res;
          this.formData = data;
          console.log(`===`, res);
          if (this.from == "home" && retCd == "0") {
            let state = data.state;
            if (state == 0 || state == 1) {
              this.$router.replace("/new/insureDetail");
            } else if (state == 2) {
              this.$router.replace("/new/createSuccess?state=0");
            } else if (state == 3) {
              this.$router.replace("/new/createSuccess?state=1");
            }
          }
          this.handleBssid();
          if (this.isFromWifiList) {
            this.handleWifiaaaaa();
          }
        })
        .catch((err) => {
          this.handleWifiaaaaa();
        });
    },

    handleWifiaaaaa() {
      const selectWifi = JSON.parse(
        sessionStorage.getItem("SELECT_WIFI") || null
      );
      const array = (selectWifi.bssid && selectWifi.bssid.split(":")) || [];
      if (!selectWifi) return
      var bssidList = [];
      // 分解bssid参数赋值给页面
      array.map((res, index) => {
        let obj = {
          title: res.slice(0, 1),
          title1: res.slice(1, 2),
        };
        bssidList.push(obj);
      });
      this.formData.apInfoList[selectWifi.key].bssidList = bssidList;
      this.$trace.trace("ins_join_mac_fill");
      const apInfo = this.formData.apInfoList[selectWifi.key] || {};
      Object.assign(apInfo, selectWifi);
      this.$trace.trace("ins_join_ssid_fill");
      delete apInfo["key"];
      this.formData.apInfoList[selectWifi.key] = apInfo;
      console.log(`======`, apInfo, this.formData);
    },
    // 分割Bssid
    handleBssid() {
      let apInfoList = this.formData.apInfoList;
      apInfoList &&
        apInfoList.map((res, key) => {
          console.log(`this.columns[res.merchantType]`, this.columns[res.merchantType])
          res = { ...res, ...this.columns[res.merchantType] };
          const array = (res.bssid && res.bssid.split(":")) || [];
          var bssidList = [];
          // 分解bssid参数赋值给页面
          array.map((res, index) => {
            let obj = {
              title: res.slice(0, 1),
              title1: res.slice(1, 2),
            };
            bssidList.push(obj);
          });

          this.formData.apInfoList[key] = res;
          this.formData.apInfoList[key].bssidList = bssidList;
        });
    },
    create() {
      console.log(`from=====`, this.formData);
      console.log(`填写页面，点参保按钮`);
      this.$trace.trace('ins_join_btn', "sup")

      if (this.checkName() && this.checkIDCard() && !this.hasEmpty()) {
        if (this.checked) {
          safe.confirm({
            title: "温馨提示",
            content:
              "众安保险提醒您:请确保您的信息真实有效，以保障您后期的索赔权益，否则将失去索赔权益",
            callback: () => {
              $(".model").hide();
              this.saveUserInfo();
            },
          });
        } else {
          safe.model({
            title: "温馨提示",
            content: "同意《WiFi万能钥匙商户热点安全保险协议》才能参保",
            foot: "我知道了",
          });
        }
      }
      safe.bindModelEvent();
    },
    // 选择wifi
    selectWifi(val) {
      this.$trace.trace("ins_join_ssid_nearby");
      this.$router.push({
        path: "/new/wifiSelect",
        query: {
          key: val,
        },
      });
    },
    onConfirm(value) {
      this.handleParams(value, "apInfoList");
      this.showPopup = false;
    },

    onChange(e, value) {
      this.handleParams(value, "apInfoList");
    },

    handleParams(val, type) {
      if (type === "apInfoList") {
        const { apInfoList } = this.formData;
        const apInfoItem = apInfoList[this.selectNo];
        apInfoItem.merchantType = apInfoItem.id;
        console.log(`apInfoItem====`, apInfoItem)
        Object.assign(apInfoItem, val);
        this.formData.apInfoList[this.selectNo] = apInfoItem;
      } else {
        console.log(`apInfoItem====`, val)
        Object.assign(this.formData, val);
      }
    },

    onCancel() {
      this.showPopup = false;
    },

    // 提交信息
    saveUserInfo() {
      this.loading = true;
      // var obj = {
      //   userName: "",
      //   idCard: "410523191003228",
      //   businessLicense:
      //     "http://uimg01.51y5.net/wk003/M00/5C/B2/CgIagV9dqpeAZybrAABpUM_9h7M622.png",
      //   apInfoList: JSON.stringify([
      //     {
      //       bssid: "8c:a6:df:07:ab:422",
      //       hotspotEvidence:
      //         "http://uimg01.51y5.net/wk003/M00/5C/B2/CgIagV9dqpeAZybrAABpUM_9h7M622.png",
      //       merchantType: "",
      //       ssid: "TP-LINK_AB42",
      //     },
      //   ]),
      // };


      let apInfoList = this.formData.apInfoList;
      let array = []
      apInfoList.map((res) => {
        res.merchantType = res.id
        let bssidArray = ''
        res.bssidList.map((obj, index)=>{
          if (index < 5) {
            bssidArray = `${bssidArray}${obj.title}${obj.title1}:`
          } else {
            bssidArray = `${bssidArray}${obj.title}${obj.title1}`
          }
        })
        res.bssid = bssidArray
        array.push(res)
      });
      this.formData.apInfoList = array


      if (this.checkParams()) {
        return;
      }

      let apInfoListString = JSON.stringify(this.formData.apInfoList);
      let params = {
        ...this.formData,
        apInfoList: apInfoListString,
      };
      commitInsurance(params)
        .then((res) => {
          const { retCd, msg } = res;
          this.loading = false;
          this.callNotifyAction();
          this.$router.replace({
            path: "/new/createSuccess",
          });
        })
        .catch((err) => {
          const { retCd, msg } = err;
          if (retCd === "-1") {
            this.$toast(msg);
            // this.$toast("提交失败");
          } else {
            this.$toast(msg);
          }
          this.loading = false;
        });
    },

    callNotifyAction () {
      Utils.Bridge.call('notifyAction', {
          event: 'insurance',
      });
    },
    // 验空处理
    checkParams() {
      let apInfoList = this.formData.apInfoList;
      apInfoList.map((res) => {
        for (var key in res) {
          console.log(`======`, res);
          if (res['bssid'] === "" || res['ssid'] === "" || res['hotspotEvidence'] === "" || res['merchantType'] === "") {
            safe.model({
              title: "温馨提示",
              content: "请填写完整再提交保单",
              foot: "我知道了",
            });
            return true;
          }
        }
      });
      return false;
    },

    getHotspotEvidence() {
      this.$trace.trace("ins_join_certif");
    },
    getBusinessLicense() {
      this.$trace.trace("ins_join_blis");
    },
    hasEmpty() {
      for (var key in this.formData) {
        if (this.formData[key] === "") {
          safe.model({
            title: "温馨提示",
            content: "请填写完整再提交保单",
            foot: "我知道了",
          });
          return true;
        }
      }
      if (!this.formData.businessLicense) {
        safe.model({
          title: "温馨提示",
          content: "请填写完整再提交保单",
          foot: "我知道了",
        });
        return true;
      }
      return false;
    },
    handleShopType(key) {
      this.$trace.trace("ins_join_type");
      this.showPopup = true;
      this.selectNo = key;
    },
    copyQq(val) {
      var clipboard = new Clipboard(".copy-qq", {
        text: function () {
          return val;
        },
      });
      clipboard.on("success", (e) => {
        Toast("复制成功");
        this.cancel();
        console.info("触发的方式（复制还是剪切）", e.text);
      });
    },
    checkIDCard() {
      var idcard = this.formData.idCard;
      var _id = this.parseID(idcard);
      if (isNaN(_id.substr(0, 17))) {
        safe.model({
          title: "温馨提示",
          content: "身份证号码格式有误",
          foot: "我知道了",
        });
        return false;
      }
      return true;
    },

    // 添加、删除WiFi
    handleWifi(type, key) {
      if (type === "add") {
        this.$trace.trace("ins_join_ssid_add");
        if (this.formData.apInfoList.length >= 3) {
          this.$toast("最多可添加三个热点");
          return;
        }
        this.$toast("添加热点成功");
        let obj = {
          bssid: "",
          ssid: "",
          hotspotEvidence: "",
          merchantType: "",
          bssidList: [
            { title: "", title1: "" },
            { title: "", title1: "" },
            { title: "", title1: "" },
            { title: "", title1: "" },
            { title: "", title1: "" },
            { title: "", title1: "" },
          ],
        };
        this.formData.apInfoList.push(obj);
      } else {
        this.$toast("删除热点成功");
        this.$trace.trace("ins_join_ssid_del");
        let array = [];
        this.formData.apInfoList.map((res, i) => {
          if (key !== i) {
            array.push(res);
          }
        });
        this.formData.apInfoList = array;
      }
    },

    checkName() {
      var reg = /^([\uFF0E\uFF07\uFF0F\.\•\·\uFF0D\u4E00-\u9FA5\uF900-\uFA2D\uB0A1-\uF7FE]{2,15})$/,
        username = this.formData.userName;
      if (!reg.test(username)) {
        safe.model({
          title: "温馨提示",
          content: "姓名格式不正确",
          foot: "我知道了",
        });
      } else {
        return true;
      }
    },
    eidtSsid(val) {
      console.log(`val======`, val)
      this.$trace.trace("ins_join_ssid");
    },
    eidtMac() {
      if (this.isFirstClickMac) {
        this.isFirstClickMac = false
        this.$trace.trace("ins_join_mac");
      }
    },
    eidtName() {
      this.$trace.trace("ins_join_name", "sup");
    },
    eidtCard() {
      this.$trace.trace("ins_join_id", "sup");
      console.log(`身份证号输入框`);
    },
    changeCheck(val) {
      this.$trace.trace("ins_join_agreement", "sup");
    },
    clickProtocol(val) {
    },
    cancel() {
      this.showAlertModel = false;
    },

    parseID: function (pId) {
      var arrVerifyCode = [1, 0, "x", 9, 8, 7, 6, 5, 4, 3, 2];
      var wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      if (pId.length != 15 && pId.length != 18) {
        return "身份证号码只能是15位或18位!";
      }
      var ai =
        pId.length == 18
          ? pId.substr(0, 17)
          : pId.substr(0, 6) + "19" + pId.substr(6);
      if (!/^\d+$/.test(ai)) {
        return "身份证除最后一位外，必须为数字！";
      }
      var yyyy = ai.substr(6, 4),
        mm = ai.substr(10, 2) - 1,
        dd = ai.substr(12, 2);
      var d = new Date(yyyy, mm, dd),
        year = d.getFullYear(),
        mon = d.getMonth(),
        day = d.getDate(),
        now = new Date();
      if (
        year != yyyy ||
        mon != mm ||
        day != dd ||
        d > now ||
        now.getFullYear() - year > 140
      ) {
        return "身份证出生年月日输入错误！";
      }
      for (var i = 0, ret = 0; i < 17; i++) {
        ret += ai.charAt(i) * wi[i];
      }
      ai += arrVerifyCode[(ret %= 11)];
      return pId.length == 18 && pId.toLowerCase() != ai
        ? "身份证输入错误，正确的为\n" + ai + "！"
        : ai;
    },
  },
};
</script>

<style scoped>
@import "../mobiscroll/css/mobiscroll.animation.css";
@import "../mobiscroll/css/mobiscroll.frame.css";
@import "../mobiscroll/css/mobiscroll.frame.android-holo.css";
@import "../mobiscroll/css/mobiscroll.scroller.css";
@import "../mobiscroll/css/mobiscroll.scroller.android-holo.css";
@import "../mobiscroll/css/mobiscroll.android-holo-light.css";
.f12 {
  font-size: 12px;
}
.f14 {
  font-size: 14px;
}
.c3 {
  color: #333;
}
.fb {
  font-weight: bold;
}
.t_c {
  text-align: center;
}
.ti {
  text-indent: 18px;
}
.store-form {
  color: #666666;
  padding: 0 0px;
  background-color: #ffffff;
  padding-top: 5px;
}
.store-form .label {
  position: relative;
  padding-top: 18px;
  padding-left: 0;
  min-height: 46px;
  display: flex;
  flex-direction: column;
}
.store-form label {
  width: 100%;
  font-size: 15px;
  font-weight: bold;
  color: #333333;
  letter-spacing: 0;
  line-height: 20px;
}
.store-form input {
  /* position: absolute; */
  left: 25%;
  width: 100%;
  overflow: hidden;
  height: 45px;
  line-height: 14px;
  font-size: 14px;
  color: #666666;
  border: none;
  background-color: transparent;
  word-break: keep-all;
  white-space: nowrap;
}
.store-form .arrow {
  position: absolute;
  right: 0;
  bottom: 16px;
  width: 11px;
  height: 13px;
  background: url(../images/arrow.png) top center no-repeat;
  -webkit-background-size: 100%;
  background-size: 100%;
}
.select-wifi {
  position: absolute;
  right: 0;
  bottom: 7px;
  display: flex;
  width: 120px;
  height: 30px;
  align-items: center;
  color: #1890ff;
  font-size: 14px;
  background-image: linear-gradient(
    -90deg,
    rgba(66, 169, 253, 0.1) 0%,
    rgba(2, 133, 240, 0.1) 99%
  );
  border-radius: 16.5px;
  justify-content: center;
}
.select-wifi .arrow-right {
  bottom: 16px;
  width: 6px;
  height: 10px;
  margin-left: 4px;
}

input {
  background: none;
}
input[placeholder],
[placeholder],
*[placeholder] {
  word-break: keep-all;
  white-space: nowrap;
}

.user-info {
  position: relative;
  margin: 0 20px;
}
.upload-img {
  background: #f7f7f7;
  /* border: 1px solid #E8E8E8; */
  border-radius: 4px;
  margin: 10px 0;
  width: 86px;
  height: 86px;
}

.wifi-body {
  position: relative;
}

.wifi-info {
  position: relative;
  margin: 0 20px;
}
.wifi-info section {
  padding: 0 20px;
}

.line {
  position: relative;
  background: #f5f5f5;
  height: 10px;
  width: 100%;
}

.wifi-info p {
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  line-height: 21px;
  padding: 10px 0 0;
}

.store-form .bn {
  border: none;
}
.log_title span {
  display: block;
  width: 35%;
  height: 44px;
  line-height: 44px;
  padding-left: 58px;
  margin: 0 auto;
  font-size: 24px;
  color: #333333;
  background: url(../images/gou.png) no-repeat 0 0;
  background-size: 44px 44px;
}

.alert-model {
  position: fixed;
  top: 0;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
}
.alert-model .body {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -45%;
  margin-top: -90px;
  border-radius: 3px;
  width: 90%;
  background-color: #ffffff;
}
.alert-model .title {
  font-weight: normal;
  padding-left: 24px;
  margin-top: 16px;
  font-size: 18px;
}

.alert-model .content {
  color: #484a50;
  font-size: 15px;
  line-height: 20px;
  padding: 0 24px 12px 24px;
  margin-top: 7px;
}

.alert-model .description {
  font-size: 13px;
  line-height: 20px;
  padding: 0 24px 0px 24px;
  margin-bottom: 0px;
  color: #999999;
}
.alert-model .foot {
  text-align: center;
  line-height: 54px;
}
.alert-model .foot {
  color: #0285f0;
  font-size: 17px;
  text-align: center;
  line-height: 54px;
  border: none;
}
.alert-model .foot,
.alert-model .btns {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAABlBMVEUAAADb29tXdnSWAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjYGA4AAAAxADBPcXUKgAAAABJRU5ErkJggg==);
  background-repeat: repeat-x;
  background-position: 0 top;
  background-size: auto 1px, 1px auto;
  display: flex;
  padding: 0;
}
.alert-model img {
  margin-top: 3px;
  width: 14px;
  margin-right: 4px;
}
.copy-qq {
  font-size: 13px;
  color: #0285f0;
  letter-spacing: 0;
  line-height: 13px;
  padding: 12px 10px;
}
.alert-model .cancel,
.alert-model .confirm {
  text-align: center;
  display: inline-block;
  width: 50%;
  box-sizing: border-box !important;
  -webkit-box-sizing: border-box !important;
  line-height: 20px;
  font-size: 17px;
}
.alert-model .cancel {
}
.alert-model .confirm {
  border-left: 1px #f2f2f2 solid;
  color: #0285f0;
}

.claimNumber {
  line-height: 20px;
  color: #ee5d4d;
  border-bottom: #cccccc 1px dotted;
  padding-bottom: 10px;
}
.claimNumber span {
  font-size: 20px;
}

.title {
  font-size: 16px;
  color: #0285f0;
  line-height: 20px;
}
.title2 {
  font-size: 12px;
  color: #666666;
  font-weight: bold;
  line-height: 20px;
  margin: 16px 0;
}
.title_bold {
  font-size: 12px;
  color: #333333;
  font-weight: bold;
  line-height: 22px;
}
.label {
  font-size: 14px;
  color: #333333;
}

.error {
  color: #ee5d4d;
  font-size: 12px;
}
.error input {
  color: #ee5d4d;
  font-size: 12px;
}
.notes {
  margin-top: 17px;
  margin-bottom: 2px;
}
.text {
  font-size: 12px;
  color: #666666;
  line-height: 24px;
  margin-bottom: 3px;
}

.protocol {
  font-size: 13px;
  line-height: 24px;
}
.protocol span {
  color: #0285f0;
}
.protocol a {
  text-decoration: underline;
}

.errorMsg {
  color: #ee5d4d;
  font-size: 12px;
  line-height: 24px;
  display: none;
}
.buttons {
  margin-bottom: 36px;
}
a.button {
  display: block;
  height: 46px;
  width: 100%;
  text-decoration: none;
  font-size: 18px;
  line-height: 46px;
  text-align: center;
  -webkit-border-radius: 23px;
  -moz-border-radius: 23px;
  border-radius: 23px;
  color: #ffffff;
  background: -webkit-linear-gradient(left, #42a9fd, #0285f0);
}

.voucher {
  font-size: 14px;
  color: #0285f0;
  position: absolute;
  bottom: 24px;
  text-align: center;
  width: 100%;
}
.mbsc-android-holo-light .dwb-a {
  background: #ebebeb;
}
.mbsc-android-holo-light .dwwol {
  border-top: 1px solid #0285f0;
  border-bottom: 1px solid #0285f0;
}
.mbsc-android-holo-light .dwv {
  color: #0285f0;
  border-bottom: 1px solid #0285f0;
  line-height: 2.8em;
}
.mbsc-android-holo .dwb {
  height: 3.6em;
  line-height: 3.6em;
}
.logo-image {
  margin-top: 30px;
  width: 100%;
  padding-top: 2.9%;
  background: url(../images/index/logo-image.png) no-repeat center;
  background-size: contain;
}
.copyright {
  font-size: 12px;
  line-height: 26px;
  color: #e0e0e0;
  text-align: center;
  font-weight: 300;
}
.store-form {
  position: relative;
}

.footer {
  /* margin-top: -15px; */
  background: #fff;
  margin-bottom: 12px;
  padding-bottom: 8px;
}

.footer .notice {
  color: #333;
  font-size: 14px;
  margin-top: 18px;
  letter-spacing: 0;
  font-weight: bold;
  line-height: 26px;
}
.footer .noticeIngo {
  color: #151515;
  font-size: 14px;
  line-height: 26px;
}
.macList {
  list-style: none;
  margin: 0;
  line-height: 40px;
  padding: 0;
}

.macList li {
  float: left;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 16.6%;
  /* padding-right: 4px; */
  position: relative;
}

.macList li input:first-child {
  margin-right: 0px;
  text-align: right;
}

.macList input {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: left;
  width: 40%;
  line-height: inherit;
  border: 1px solid #d0d0d0;
  border-width: 0 0 1px 0;
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  appearance: none;
  color: #484a50;
}

.macList input:focus {
  border-color: #0285f0;
}

.macList span {
  line-height: inherit;
  text-align: center;
  width: 15%;
  color: #666666;
  position: absolute;
  top: 0;
  right: 0;
}

.clearfix:after,
.clearfix:before {
  content: "";
  display: table;
}

.clearfix:after {
  clear: both;
  overflow: hidden;
}

.hide {
  display: none !important;
}
.btn-body {
  height: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.add {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.add-span {
  font-size: 16px;
  color: #0285f0;
  letter-spacing: 0;
  margin-left: 8px;
  text-align: center;
  line-height: 16px;
}
.delete-span {
  font-size: 16px;
  color: #999999;
  letter-spacing: 0;
  margin-left: 8px;
  text-align: center;
  line-height: 16px;
}
.add-img {
  width: 18px;
  height: 18px;
}
.clearfix {
  zoom: 1;
}

.footer .des {
  padding: 20px;
}
.footer h3 {
  font-size: 14px;
  color: #666666;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 26px;
}
.xing_red {
  font-size: 16px;
  color: #fe2c54;
  letter-spacing: 0;
  font-weight: bold;
  line-height: 14px;
}
.model .btns {
  display: flex;
}
.van-checkbox {
  align-items: end;
}
</style>



// WEBPACK FOOTER //
// createStore.vue?4097dba9